export default {"src":"/_next/static/media/feature-image-03.0e930d40.svg","height":250,"width":320,"blurWidth":0,"blurHeight":0};